module.exports = __webpack_public_path__ + "img/kjfwms-banner.116a4d91.jpg";